<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  seed: string
  size?: 'sm' | 'md' | 'lg' | number
}>()

const avatarSize = computed(() => {
  if (typeof props.size === 'number') return props.size
  
  // Map string sizes to pixel values
  switch (props.size) {
    case 'sm': return 32
    case 'md': return 48
    case 'lg': return 64
    default: return 48 // Default size
  }
})

const avatarUrl = computed(() => {
  // Use DiceBear API directly - CSP now allows api.dicebear.com
  return `https://api.dicebear.com/7.x/adventurer/svg?seed=${encodeURIComponent(props.seed)}&size=${avatarSize.value}`;
})
</script>

<template>
  <img 
    :src="avatarUrl" 
    :alt="`Avatar ${seed}`"
    class="rounded-full"
    :style="{ width: `${avatarSize}px`, height: `${avatarSize}px` }"
  />
</template>
